require('../../modules/es.date.now');
require('../../modules/es.date.to-json');
require('../../modules/es.date.to-iso-string');
require('../../modules/es.date.to-string');
require('../../modules/es.date.to-primitive');
var path = require('../../internals/path');

module.exports = path.Date;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/es/date/index.js
// module id = 1074
// module chunks = 0